import { Navigate } from "../../../router-utils"

export default function CreditConsumptionIndexPage() {
	return <Navigate to="/credit-consumption/all" replace />
}
